import React from 'react';

export function Chip({ tone = 'muted', children, size = 'md', style }) {
  const tones = {
    success: { bg: 'var(--success-50)',  fg: 'var(--success-700)', dot: 'var(--success-500)' },
    danger:  { bg: 'var(--danger-50)',   fg: '#8a1820',            dot: 'var(--danger-500)' },
    warning: { bg: 'var(--warning-50)',  fg: '#8a5b11',            dot: 'var(--warning-500)' },
    info:    { bg: 'var(--info-50)',     fg: 'var(--info-600)',    dot: 'var(--info-500)' },
    brand:   { bg: 'var(--yuno-purple-50)', fg: 'var(--yuno-purple-700)', dot: 'var(--yuno-purple-500)' },
    muted:   { bg: 'var(--neutral-100)', fg: 'var(--neutral-700)', dot: 'var(--neutral-400)' },
  };
  const t = tones[tone] || tones.muted;
  const pad = size === 'sm' ? '2px 8px' : '3px 10px';
  const fs = size === 'sm' ? 11 : 12;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      background: t.bg, color: t.fg,
      padding: pad, borderRadius: 999, fontSize: fs, fontWeight: 500,
      lineHeight: 1, letterSpacing: '-0.005em', whiteSpace: 'nowrap',
      ...style,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: 999, background: t.dot }} />
      {children}
    </span>
  );
}

export function ProviderBadge({ provider, size = 20, showName = false }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <span style={{
        width: size, height: size, borderRadius: 6,
        background: provider.color, color: '#fff',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        fontSize: size * 0.55, fontWeight: 700, letterSpacing: '-0.04em',
        fontFamily: 'Inter, sans-serif',
      }}>{provider.glyph}</span>
      {showName && <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--fg-1)' }}>{provider.name}</span>}
    </span>
  );
}
